import { render, staticRenderFns } from "./Box1.vue?vue&type=template&id=3b817cc4"
import script from "./Box1.vue?vue&type=script&lang=js"
export * from "./Box1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports